import { RenderOptions } from '../../models/element-types';
import { DomUtils } from '../../utils/dom-utils';

export interface SpecialFieldJsonData {
    id: string;
    type: string;
}

export abstract class BaseSpecialRenderer<TData extends SpecialFieldJsonData = SpecialFieldJsonData> {
    public render(data: TData, options?: RenderOptions): HTMLElement {
        const element = this.renderElement(data, options);
        element.dataset['elementJson'] = JSON.stringify(data);
        return element;
    }

    public getData(element: HTMLElement): TData | null {
        const jsonData = element.dataset['elementJson'];
        if (!jsonData) {
            return null;
        }

        try {
            return JSON.parse(jsonData) as TData;
        } catch (e) {
            console.error('Failed to parse element data:', e);
            return null;
        }
    }

    public createNew(options?: RenderOptions): HTMLElement {
        const defaultData = this.createDefaultData();
        return this.render(defaultData, options);
    }

    protected createDefaultData(): TData {
        const data = this.defaultData;
        data.id = this.generateId();
        return data;
    }

    protected generateId(): string {
        return DomUtils.generateUniqueElementId([]);
    }

    /**
     * Create error container for validation messages
     */
    protected createErrorContainer(): HTMLElement {
        const container = document.createElement('div');
        container.classList.add('field-error-container');
        container.setAttribute('role', 'alert');
        container.setAttribute('aria-live', 'polite');
        return container;
    }

    protected abstract get defaultData(): TData;
    protected abstract renderElement(data: TData, options?: RenderOptions): HTMLElement;
}
